import React, { FC } from "react";

// Services
import { numPrettier } from "services/TextPrettierService";

// Interfaces
import { DRCalendarOutput, DRCalendarValues } from "types/DRInterface";

const RepaymentCalendarBody: FC<{ values: DRCalendarOutput }> = (props) => {
  return (
    <div className="calendar__table-body">
      {props.values.map((calendar: DRCalendarValues, key: number) => {
        return (
          <div className="calendar__table-row" key={key}>
            <div className="calendar__table-cell text text--secondary">
              <span className="text text--secondary">{numPrettier(key + 1)}</span>
            </div>
            <div className="calendar__table-cell text text--secondary">
              <span className="text text--secondary">${numPrettier(calendar.beginningBalance)}</span>
            </div>
            <div className="calendar__table-cell text text--secondary">
              <span className="text text--secondary">${numPrettier(calendar.principal)}</span>
            </div>
            <div className="calendar__table-cell text text--secondary">
              <span className="text text--secondary">${numPrettier(calendar.interest)}</span>
            </div>
            <div className="calendar__table-cell text text--secondary">
              <span className="text text--secondary">${numPrettier(calendar.endingBalance)}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RepaymentCalendarBody;
